// Copyright ©️ 2026 eVolve MEP, LLC

import type { Company, PermissionLevel, AssignableRole, RoleEntry } from '@evolvemep/api-ts';

export const permissionOptions = [
  { label: 'Read/Write', value: 'Full' },
  { label: 'Read Only', value: 'ReadOnly' },
] as const satisfies {
  label: string;
  value: PermissionLevel;
}[];

export type NameableRole = {
  defaultDisplayName: string;
  eERole: AssignableRole | undefined;
  eMRole: AssignableRole | undefined;
};

export type RoleNameFormEntries = {
  optInToCustomRolePermissions: boolean | null;
  roles: {
    [key: AssignableRole['defaultDisplayName']]: {
      eERole: AssignableRole | undefined;
      eMRole: AssignableRole | undefined;
    };
  };
};

export type RoleToRemove = RoleEntry & {
  userDisplayName: string;
};

export type RoleOption = {
  assigned: boolean;
};

export type RoleAndPermissionModalContentsProps = {
  roles: AssignableRole[];
  hasRevitRoles: boolean;
  hasMechanical: boolean;
  hasElectrical: boolean;
  company: Company | undefined;
  refetch: () => void;
};

export type HasProductsAvailable = {
  revitRoles: boolean;
  electrical: boolean;
  mechanical: boolean;
  shop: boolean;
};
